export default [
  {
    path: '/documents',
    component: () => import('@/layouts/GeneralLayout.vue'),
    children: [
      {
        path: 'folders',
        name: 'folders',
        component: () => import('@/views/documents/folders/Index.vue'),
        meta: {
          redirectIfGuest: true,
          resource: 'documents',
          action: 'access-folders',
        },
      },
      {
        path: 'trash',
        name: 'trash',
        component: () => import('@/views/documents/trash/Index.vue'),
        meta: {
          redirectIfGuest: true,
          resource: 'documents',
          action: 'access-trash-store',
        },
      },
    ],
  },
]
